import React, { useState, useCallback } from 'react'
import './settle-record.scss'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import dayjs from 'dayjs'
import Table, { ColumnsType } from 'antd/lib/table'
import { Column, Expaned, Row } from '@/components/layout/layout'
import { DatePicker } from 'antd'
import Big from 'big.js'
import { AutoResizer } from '@/utils/utils-widget'
import { formatPrice, errorCallBack } from '@/utils'
import { Modal } from '@/components/dialog/modal'
import copy from 'copy-to-clipboard'
import $msg from '@/utils/message'

interface ISettleInfo {
    clearing_settle_subtotal: number
    merchant_no: string
    online_subtotal: number
    service_rate: number
    statistics_date: string
}

interface IRateList {
    rate_code: string
    rate_data: number
    type: string
}

const SettleDes = () => {
    return (
        <Modal
            type="success"
            title="清算说明"
            isShow
            showCancel={false}
            onClose={() => layerManage.pop()}
            onConfirm={() => layerManage.pop()}
            okText="知道了"
        >
            <Column data-color-000 data-font-size-14>
                <Row>
                    <div>1.</div>
                    <div className="settle_des">
                        到账时间一般为D+1(第二天到账)，因清算机构差异，可能存在 T+1(下一工作日到账)。
                    </div>
                </Row>
                <Row>
                    <div>2.</div>
                    <div className="settle_des">因清算机构差异，同一天应入账款可能存在分多次到账情况。</div>
                </Row>
                <Row>
                    <div>3.</div>
                    <span className="settle_des">
                        如遇结算金额未到账、结算金额与到账金额不一致等情况，请 联系森果客服：
                        <span
                            className="action"
                            onClick={() => {
                                copy('400-027-0135')
                                $msg('success', '复制成功')
                            }}
                        >
                            400-027-0135
                        </span>{' '}
                        进行处理
                    </span>
                </Row>
            </Column>
        </Modal>
    )
}

const SettleRecord = () => {
    const [date, setDate] = useState<[string, string]>([
        dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
    ])

    const requestHandle = useRequest<{
        merchant_clearing_settle_info: ISettleInfo[]
        rate_list: IRateList[]
    }>(
        () =>
            $post({
                url: '/finance/getlcswsettlementhistory',
                params: {
                    from_date: date[0],
                    to_date: date[1],
                },
            }),
        {
            refreshDeps: [date],
            onError: errorCallBack,
        },
    )

    const columns: ColumnsType<ISettleInfo> = [
        {
            title: '结算时间',
            dataIndex: 'statistics_date',
            width: 150,
        },
        {
            title: '在线支付',
            dataIndex: 'online_subtotal',
            align: 'right',
            width: 200,
            render: v => formatPrice(v),
        },
        {
            title: '手续费',
            dataIndex: 'service_rate',
            align: 'right',
            width: 160,
            render: v => formatPrice(v),
        },
        {
            title: '结算金额',
            width: 220,
            dataIndex: 'clearing_settle_subtotal',
            align: 'right',
            render: v => formatPrice(v),
        },
    ]

    const getRate = useCallback((rate: number) => {
        return +Big(1).times(rate).times(100).toFixed(2)
    }, [])

    return (
        <BaseDrawer width={781} isShow onClose={() => layerManage.pop()} title="清算记录">
            <Column data-overflow-hidden data-height-100p>
                <Row data-align-items-center data-margin-top-16 data-justify-content-space-between>
                    <Row data-align-items-center>
                        <div data-color-333 data-font-size-16 data-margin-left-16>
                            当前手续费率：微信{getRate(requestHandle.data?.rate_list[0].rate_data || 0)}%，支付宝
                            {getRate(requestHandle.data?.rate_list[1].rate_data || 0)}%
                        </div>
                        <div
                            className="action"
                            style={{ fontSize: '16px' }}
                            data-margin-left-16
                            onClick={() => {
                                showLayer(<SettleDes />)
                            }}
                        >
                            清算说明
                        </div>
                    </Row>
                    <div className="time-picker" data-margin-right-16>
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                if (dateString[0]) {
                                    setDate(dateString)
                                }
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                </Row>

                <Expaned className="table-container-line">
                    <AutoResizer>
                        {({ height }) => {
                            return (
                                <Table
                                    rowKey={record => record.merchant_no}
                                    bordered
                                    loading={requestHandle.loading || void 0}
                                    pagination={false}
                                    columns={columns}
                                    dataSource={requestHandle.data?.merchant_clearing_settle_info || []}
                                    scroll={{ x: 'max-content', y: height - 50 }}
                                />
                            )
                        }}
                    </AutoResizer>
                </Expaned>
            </Column>
        </BaseDrawer>
    )
}

export default SettleRecord
